<div class="card product-card h-100">
  <div class="media">
    <img [src]="p.images[0]" [alt]="p.name" class="media__img" loading="lazy" decoding="async">
  </div>

  <div class="card-body d-flex flex-column">
    <a class="stretched-link text-reset" [routerLink]="['/producto', p.slug]">
      <h6 class="title mb-1">{{ p.name }}</h6>
    </a>

    <p class="desc text-secondary small mb-2" *ngIf="p.shortDesc">{{ p.shortDesc }}</p>

    <div class="meta d-flex justify-content-between align-items-center mb-2">
      <strong class="price" *ngIf="p.salePolicy !== 'QUOTE'">
        {{ p.price | currency:'PEN':'symbol-narrow' }}
      </strong>
      <span class="badge text-bg-light" *ngIf="p.series">{{ p.series }}</span>
    </div>

    <div class="actions mt-auto">
      <a class="btn btn-pro-ghost btn-sm" [routerLink]="['/producto', p.slug]">
        <i class="bi bi-eye"></i><span>Ver detalle</span>
      </a>

      <button class="btn btn-pro-outline btn-sm"
              *ngIf="p.salePolicy !== 'BUY'"
              (click)="addToQuote()">
        <i class="bi bi-clipboard-check"></i><span>Cotizar</span>
      </button>

      <button class="btn btn-pro btn-sm"
              *ngIf="p.salePolicy !== 'QUOTE'"
              (click)="addToCart()">
        <i class="bi bi-cart-plus"></i><span>Agregar</span>
      </button>
    </div>
  </div>
</div>
